// this file is automatically generated by version.sh script
export const version: Version = {
  version: '3.2.19',
  revision: '2a4ea5308',
  branch: 'HEAD',
  timestamp: '02.11.2026'
};

export interface Version {
  revision: string;
  version: string;
  branch: string;
  timestamp: string;
}
